// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
// NgRx actions / selectors
import { setChartOption } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-options/chart-options.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const legendOnChart = createReducer(false, on(setChartData, (state, { chartData }) => chartData.params.legendOnChart), on(setChartOption, (state, action) => action.chartOption.value === FundChartOptionValue.LEGEND_ON_CHART ? action.chartOption.selected : state));
